import React from "react";
import {
  BsGrid1X2Fill,
  BsPeopleFill,
  BsFillGearFill,
  BsFillQuestionCircleFill
} from "react-icons/bs";

import { 
  FaRupeeSign, 
  FaExchangeAlt, 
  FaUniversity,
  FaPiggyBank,
  FaShieldAlt
} from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";

import { Link } from "react-router-dom";
import logo2 from "../../../assets/images/logo2.png";

function Sidebar({ openSidebarToggle, OpenSidebar }) {
  return (
    <aside
      id="sidebar"
      className={openSidebarToggle ? "sidebar-responsive" : ""}
    >
      {/* LOGO */}
      <div className="sidebar-title">
        <div
          className="sidebar-brand"
          style={{
            marginTop: "15px",
            height: "8rem",
            width: "10rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={logo2}
            alt="logo"
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain",
              boxShadow: "0 4px 8px rgba(0,0,0,1)",
            }}
          />
        </div>

        <span className="icon close_icon" onClick={OpenSidebar}>
          X
        </span>
      </div>

      {/* MENU */}
      <ul className="sidebar-list">

        {/* CORE */}
        <li className="sidebar-list-item">
          <Link to="/admin-dashboard">
            <BsGrid1X2Fill className="icon" /> Dashboard
          </Link>
        </li>

        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/staffs">
            <FaPeopleGroup className="icon" /> Staffs
          </Link>
        </li>

        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/customers">
            <BsPeopleFill className="icon" /> Customers
          </Link>
        </li>

        {/* TRANSACTIONS */}
        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/credit-debit">
            <FaRupeeSign className="icon" /> Credit / Debit
          </Link>
        </li>

        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/transactions">
            <FaExchangeAlt className="icon" /> Transactions
          </Link>
        </li>

        {/* FINANCIAL PRODUCTS */}
        <li className="sidebar-list-item mt-3 text-muted" style={{ fontSize: "12px", paddingLeft: "10px" }}>
          FINANCIAL PRODUCTS
        </li>

        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/loans">
            <FaUniversity className="icon" /> Loans
          </Link>
        </li>

        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/fds">
            <FaPiggyBank className="icon" /> Fixed Deposits
          </Link>
        </li>

        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/insurance">
            <FaShieldAlt className="icon" /> Insurance
          </Link>
        </li>

        {/* SUPPORT */}
        <li className="sidebar-list-item mt-3 text-muted" style={{ fontSize: "12px", paddingLeft: "10px" }}>
          SUPPORT
        </li>

        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/tickets">
            <BsFillQuestionCircleFill className="icon" /> Queries
          </Link>
        </li>

        {/* SETTINGS */}
        <li className="sidebar-list-item">
          <Link to="/admin-dashboard/settings">
            <BsFillGearFill className="icon" /> Settings
          </Link>
        </li>

      </ul>
    </aside>
  );
}

export default Sidebar;
